import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledContactUsSection = styled.section`
  margin: 0 auto;
  text-align: center;

  & h2 {
    margin-bottom: 3rem;
    font-family: var(--font-geomanist);
    color: var(--color-primary);
    font-weight: 500;
    font-size: 28px;
    line-height: 35px;
    text-align: center;

    @media ${breakpoints.tablet} {
      font-size: 36px;
    }
  }

  .items-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    margin-bottom: 6rem;

    @media ${breakpoints.tablet} {
      flex-direction: row;
      gap: 6rem;
    }

    .item {
      display: flex;
      flex-direction: row;
      gap: 0.8rem;
      justify-content: center;

      .item-text {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .info {
          font-family: var(--font-geomanist);
          font-weight: 500;
          font-size: 20px;
          color: var(--color-primary);
          text-decoration: underline;
          text-align: left;
        }

        .extra-info {
          font-family: var(--font-geomanist);
          font-weight: 200;
          font-size: 14px;
          color: var(--color-black);
        }
      }
    }
  }
`;
